// extracted by mini-css-extract-plugin
export default {"expand":"Footer--expand--X5OzP","controls":"Footer--controls--pTHlF"};